<div>
  <app-nav-bar></app-nav-bar>

  <div class="c43 c51 doc-content">
    <p class="c19 c33" id="h.gjdgxs"><span class="c0"></span></p>
    <p class="c27 c43"><span class="c50">PRIVACY POLICY - BHARAT KHATA</span></p>
    <p class="c7"><span class="c0"></span></p>
    <p class="c9"><span class="c16">Last updated 12</span><span class="c16 c48">th</span><span class="c0">&nbsp;March
        2024</span></p>
    <p class="c3"><span class="c0"></span></p>
    <p class="c3"><span class="c0"></span></p>
    <p class="c9"><span class="c0">We at Greenizon Agritech Consultancy Private Limited (herein after referred to as
        &quot;Jai Kisan&rdquo;, &quot;Bharat Khata&rdquo; &ldquo;we,&quot; &quot;us,&quot; or &quot;our&quot;) know
        that our Users (herein after referred to as &quot;you,&quot; &quot;your,&quot; or &quot;yourself&quot;) care
        about how your personal information is used and shared, and we take your privacy seriously. Please read the
        following to learn more about our Privacy Policy. By visiting or using Bharat Khata Mobile Application,
        websites and domain names, any other linked pages, features, content, and any other services we offer from
        time to time in connection with any of the foregoing (collectively, the &quot;Mobile App&quot;), you agree
        to the practices and policies set forth in this Privacy Policy, and you hereby acknowledge and consent to
        our collection, use, and sharing of your information as described in this Privacy Policy. Capitalized terms
        that are not defined in this Privacy Policy have the meaning given to them in our Terms of Service.</span>
    </p>
    <p class="c3"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-0 start" start="1">
      <li class="c9 c15 li-bullet-0"><span class="c5">WHAT DOES THIS PRIVACY POLICY COVER?</span></li>
    </ol>
    <p class="c3"><span class="c5"></span></p>
    <p class="c9"><span class="c0">This Privacy Policy covers our treatment of personally identifiable information which
        includes but not limited to any data about an individual who is identifiable by or in relation to such data,
        (&quot;Personal Information&quot;) that we gather when you are accessing or using our Mobile App. This
        policy does not apply to the practices of companies that we do not own or control, or to individuals that we
        do not employ or manage, even if you have accessed the websites or services of those companies through our
        Mobile App.</span></p>
    <p class="c3"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-0" start="2">
      <li class="c9 c15 li-bullet-0"><span class="c5">ARE CHILDREN ALLOWED TO USE OUR MOBILE APP?</span></li>
    </ol>
    <p class="c3"><span class="c5"></span></p>
    <p class="c9"><span class="c0">No children are allowed to use our App since use of our Mobile App is available only
        to persons who can form a legally binding contract under the Indian Contract Act, 1872.</span></p>
    <p class="c3"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-0" start="3">
      <li class="c9 c15 li-bullet-0"><span class="c5">WHAT INFORMATION DOES JAI-KISAN COLLECT?</span></li>
    </ol>
    <p class="c3"><span class="c5"></span></p>
    <p class="c9"><span class="c0">We gather various types of Personal Information from our users, as explained more
        fully below. We may use this Personal Information to, among other things, personalize and improve our
        services, allow our users to set up a user account and profile, contact users, fulfill your requests for
        certain products and services, analyze how users utilize the Mobile App, or as otherwise set forth in this
        Privacy Policy. We may share certain types of Personal Information with third parties. We collect the
        following types of information.</span></p>
    <p class="c3"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-1 start" start="1">
      <li class="c8 li-bullet-1"><span class="c5">Information You Provide to Us:</span></li>
    </ol>
    <p class="c3 c25"><span class="c0"></span></p>
    <p class="c2"><span class="c0">We receive and store any information you provide to us as per the required consent
        obligation as per Digital Personal Data Protection Act, 2023. For example, we collect Personal Information
        including but not necessarily limited to your name, username, phone number, address and other billing
        information, email address, and your friends&rsquo; email addresses (which we will only use in order to
        invite them to use the app developed by us, through our referral program). </span></p>
    <p class="c3 c10"><span class="c0"></span></p>
    <p class="c2"><span class="c0">For registration purposes, we may collect personal details such as your name, mobile
        number, email ID, date of birth, etc.</span></p>
    <p class="c3 c10"><span class="c0"></span></p>
    <p class="c2"><span class="c0">For providing certain services, we may require supplementary information, including
        but not limited to your residential address, financial details, credit score, credit/debit card specifics,
        Driving License, Voter ID and Permanent Account Number (PAN) or any other officially valid documents (OVDs).
        Not sharing the requisite data may lead to certain features being restricted, unavailable, or unusable.
      </span></p>
    <p class="c3 c10"><span class="c0"></span></p>
    <p class="c2"><span class="c0">If you avail our Bharat Khata app, we shall retain, on our servers, details provided
        by you with respect to your requirements. We shall, however, ensure that we maintain reasonable information
        security practices and procedures in compliance with including but not limited to the Digital Personal Data
        Protection Act, 2023 and the Information Technology (Reasonable security practices and procedures and
        sensitive personal data or information) Rules, 2011.</span></p>
    <p class="c3 c10"><span class="c0"></span></p>
    <p class="c2"><span class="c0">You can choose not to provide us with any or all of the information we specify or
        request, but then you may not be able to register with us or to take advantage of some or all of our
        features. It is your responsibility to ensure that the information you provide us is not false, inaccurate,
        out of date or misleading information.</span></p>
    <p class="c3 c10"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-1" start="2">
      <li class="c8 li-bullet-1"><span class="c5">Usage and purpose of processing the personal data:</span></li>
    </ol>
    <p class="c3 c25"><span class="c5"></span></p>
    <p class="c19 c10"><span class="c0 c43">The abovementioned personal data will be fetched only after getting your
        consent based on the purpose for which the data has been collected. We process the personal data for the
        following purposes, based on the following grounds:</span></p>
    <p class="c19 c25 c33"><span class="c0"></span></p><a id="t.af2d4bfa53e566d585cbc2c2ac79aea69e16993c"></a><a
      id="t.0"></a>
    <table class="c36">
      <tr class="c30">
        <td class="c52" colspan="1" rowspan="1">
          <p class="c27"><span class="c23">Purpose of the processing</span></p>
        </td>
        <td class="c55" colspan="1" rowspan="1">
          <p class="c27"><span class="c23">Legal basis for the processing</span></p>
        </td>
      </tr>
      <tr class="c32">
        <td class="c12" colspan="1" rowspan="1">
          <p class="c19"><span class="c0">Communicate with you and tell you about our Products and related
              events</span></p>
        </td>
        <td class="c26" colspan="1" rowspan="1">
          <p class="c19"><span class="c0">Pursue legitimate interests to provide services</span></p>
        </td>
      </tr>
      <tr class="c29">
        <td class="c14" colspan="1" rowspan="1">
          <p class="c19"><span class="c0">Provide, improve and facilitate the delivery of our Products that you
              request</span></p>
        </td>
        <td class="c6" colspan="1" rowspan="1">
          <p class="c19"><span class="c0">Fulfill contractual obligations, or if you represent a legal entity, to
              pursue our legitimate interests</span></p>
        </td>
      </tr>
      <tr class="c32">
        <td class="c12" colspan="1" rowspan="1">
          <p class="c19"><span class="c0">Respond to your comments or questions or provide information requested
              by you</span></p>
        </td>
        <td class="c26" colspan="1" rowspan="1">
          <p class="c19"><span class="c0">Fulfill contractual obligations</span></p>
        </td>
      </tr>
      <tr class="c29">
        <td class="c14" colspan="1" rowspan="1">
          <p class="c19"><span class="c0">Improve the content and general administration of the Site and our
              services</span></p>
        </td>
        <td class="c6" colspan="1" rowspan="1">
          <p class="c19"><span class="c0">Pursue legitimate interests to provide services</span></p>
        </td>
      </tr>
      <tr class="c37">
        <td class="c12" colspan="1" rowspan="1">
          <p class="c19"><span class="c0">Provide our support services</span></p>
        </td>
        <td class="c26" colspan="1" rowspan="1">
          <p class="c19"><span class="c0">Fulfill contractual obligations</span></p>
        </td>
      </tr>
      <tr class="c30">
        <td class="c14" colspan="1" rowspan="1">
          <p class="c19"><span class="c0">Better understand how the Site is used</span></p>
        </td>
        <td class="c6" colspan="1" rowspan="1">
          <p class="c19"><span class="c0">Pursue legitimate interests to provide services</span></p>
        </td>
      </tr>
    </table>
    <p class="c3 c25"><span class="c5"></span></p>
    <p class="c3 c25"><span class="c5"></span></p>
    <ol class="c4 lst-kix_list_9-1" start="3">
      <li class="c8 li-bullet-1"><span class="c5">Information Collected Automatically:</span></li>
    </ol>
    <p class="c3 c25"><span class="c5"></span></p>
    <p class="c2"><span class="c0">Whenever you interact with our Mobile App, we automatically receive and record
        information on our server logs from the app including your IP address, &ldquo;cookie&rdquo; information, and
        the page you requested. &ldquo;Cookies&rdquo; are identifiers we transfer to your device that allow us to
        recognize or device and tell us how and when pages in our Mobile App are visited and by how many people. You
        may be able to change the preferences on your device to prevent or limit your device&rsquo;s acceptance of
        cookies, but doing so may prevent you from taking advantage of our Mobile App&rsquo;s best features. Our
        advertising partners may transmit cookies to your device when you click on ads that appear on our Mobile
        App. This Privacy Policy does not cover cookies delivered to you by any of our advertisers.</span></p>
    <p class="c3 c10"><span class="c0"></span></p>
    <p class="c2">Information collected automatically may include but not be limited to your
      operating system, IP address, browser type, mobile operating system, the manufacturer, model of your mobile
      device, location, the domain name from which you accessed the Mobile App, preferred languageand duration of
      use.<span class="c0">&nbsp;In addition, we may collect information
        about your browsing behavior, such as the date and time you visit the Mobile App, the areas or pages of the
        Mobile App that you visit, the amount of time you spend viewing the Mobile App, the number of times you
        return to the Mobile App. If we provide usage information (such as the numbers and downloading frequency of
        to the Mobile App) to our partners, we will only provide such data in aggregate form, in a manner that
        assures your anonymity. We may provide this aggregate usage information to our partners; our partners may
        use such information to understand how often and in what ways people use our Mobile App, so that our
        partners, too, can endeavor to provide you with an optimal online experience. For example, we may place a
        cookie on your device that records what products you have viewed on our Mobile App, and then provide that
        information, in non-personally-identifiable form, to a third-party website, to allow such website to show
        you ads for similar products that are available from us or from third parties.</span></p>
    <p class="c3 c10"><span class="c0"></span></p>
    <p class="c3 c10"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-1" start="4">
      <li class="c8 li-bullet-1"><span class="c5">E-mail and Other Communications:</span></li>
    </ol>
    <p class="c3 c25"><span class="c5"></span></p>
    <p class="c2"><span class="c16">We may contact you, by email or other means </span><span class="c16">only after your
        prior consent</span><sup><a href="#cmnt1" id="cmnt_ref1">[a]</a></sup><span class="c16">. For example, we
        may send you updates about new products, promotional offers, or communicate with you about your use of the
        Mobile App. Also, we may receive a confirmation when you open an email from us. If you do not want to
        receive email or other mail from us, please indicate your preference by changing your account settings
        accordingly,</span><span class="c16">&nbsp;</span><span class="c0">or email us at
        contact@bharatkhata.com.</span></p>
    <p class="c3"><span class="c0"></span></p>
    <p class="c3 c10"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-1" start="5">
      <li class="c8 li-bullet-1"><span class="c5">Information generated through the use of our application: </span>
      </li>
    </ol>
    <p class="c3 c25"><span class="c5"></span></p>
    <p class="c2"><span class="c0">Through your utilization of our application or website, we gather information such
        as:</span></p>
    <p class="c2"><span class="c0">Details pertaining to the services you avail through our application, your usage of
        the application, rewards claimed, and transactional details relating to your usage of our services or the
        services offered through our lender partners. This encompasses the types of services you request, your
        chosen method of payment, the amount, and other related transactional and financial data. You will also
        generate data during your general interaction while using the application, including during customer support
        instances.</span></p>
    <p class="c3"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-1" start="6">
      <li class="c8 li-bullet-1"><span class="c5">Information we collect from third parties:</span></li>
    </ol>
    <p class="c3 c25"><span class="c0"></span></p>
    <p class="c2"><span class="c16">We may request certain third parties to provide information about you to provide
        specific services and authenticate your information.</span></p>
    <ul class="c4 lst-kix_list_6-0 start">
      <li class="c9 c39 li-bullet-1"><span class="c35">To use the application, you hereby provide your explicit
          consent for procuring your credit information from our bureau partners during the onboarding process for
          your credit limit activation. Our bureau partners are credit information companies registered under the
          Credit Information Companies (Regulation) Act 2005.</span></li>
      <li class="c9 c39 li-bullet-1"><span class="c0">To access our services, &nbsp;you hereby provide your explicit
          consent to undertake the Know Your Customer (KYC) process, which may entail us and/or our lender
          partners procuring your KYC data from one or more KYC registries.</span></li>
      <li class="c9 c39 li-bullet-1"><span class="c0">To effectuate a financial transaction, we may disseminate
          financial information provided by you (such as payment mode particulars) to authorized third parties,
          for instance, our business associates, financial institutions, or government authorities involved in the
          fulfilment of the said transactions. </span></li>
    </ul>
    <p class="c3 c41"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-1" start="7">
      <li class="c8 li-bullet-1"><span class="c5">Other Information:</span></li>
    </ol>
    <p class="c3 c25"><span class="c5"></span></p>
    <p class="c2"><span class="c0">In order to make user&#39;s onboarding process speedy, accurate &amp; smooth on the
        Bharat Khata app, we have interfaced third-party API&#39;s which will require collecting of permission and
        information from the user (including but not limited to registered contact number). This information will be
        collected from user&#39;s device after due consent is received from the user. The information collected will
        enable Jai Kisan to authenticate &amp; verify the user details for quick &amp; smooth onboarding on the
        BharatKhata App.</span></p>
    <p class="c3 c10"><span class="c0"></span></p>
    <p class="c2"><span class="c23">Below mentioned activities will be performed after receiving due consent from the
        user for each and every purpose for which the data has been fetched and used:</span></p>
    <ul class="c4 lst-kix_list_2-1 start">
      <li class="c39 c43 c44 li-bullet-1"><span class="c0">Apart from the above-mentioned personal information of the
          User, We may access other information including but not limited to Aadhar, PAN, Voter ID, Driving
          License, GST returns(if required) for KYC Purposes. </span></li>
      <li class="c9 c39 li-bullet-2"><span class="c0">We may also collect the Bank Statements or Bank Details of the
          User for verification, authentication and NACH mandate registration for repayment purposes. </span></li>
      <li class="c9 c39 li-bullet-1"><span class="c0">We may pull the credit scores of our Users from the respective
          Credit Information Company(ies) for facilitating the sanction through our Services.</span></li>
      <li class="c9 c39 li-bullet-1"><span class="c0">API will read information including but not limited to the state
          of the user&#39;s phone. For instance, information collected can be cellular network status and the
          like. Post that API will initiate a call on the user&#39;s device whose information has been submitted
          by the user. This call will be a system auto-generated call for the purpose of verification only which
          will be answered directly without the user&rsquo;s intervention in the background.</span></li>
      <li class="c28 c38 li-bullet-1"><span class="c0">The entire process has only one time applicability wherein the
          information collected from the user will be used by Bharat Khata App only once for the purpose of
          authentication &amp; verification of the user only.</span></li>
    </ul>
    <p class="c31 c43 c10"><span class="c0">The details shared by the user will not be shared with any other party apart
        from a trusted API Service Provider who will be further bound by confidentiality obligations and will be
        restricted from sharing or using the information for any other purpose apart from authentication and
        verification mentioned herein.</span></p>
    <ol class="c4 lst-kix_list_9-1" start="8">
      <li class="c8 li-bullet-1"><span class="c5">What will be done with SMS data?</span></li>
    </ol>
    <p class="c3 c25"><span class="c5"></span></p>
    <p class="c2"><span class="c16">The SMSs are a medium of confirmation of communication by the respective payment
        authenticators. Distinguished SMSs that are alphanumeric in nature, is a metric that helps have an insight
        into the payment patterns of the customer that shall help us have an insight into their spending patterns.
        The algorithm is structured in a way that it can read ONLY the alphanumeric SMSs,&nbsp;</span><span
        class="c23">after the consent is received from the customer,</span><span class="c0">&nbsp;and no other
        private message sent by any Private Individual. This information is used to assist us in performing a credit
        risk assessment, which enables us to determine the customer&rsquo;s risk profile and generate a
        &ldquo;Credit Underwriting Report&rdquo;. These Financial SMS data also includes any past information that
        the customer may have. While the customer is using the app, it will, at regular intervals, send the
        financial SMS information to the server that we share, with our affiliate, as well as to ourselves.</span>
    </p>
    <p class="c3 c10"><span class="c0"></span></p>
    <p class="c3 c10"><span class="c0"></span></p>
    <p class="c3 c10"><span class="c0"></span></p>
    <p class="c3 c10"><span class="c0"></span></p>
    <p class="c3 c10"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-1" start="9">
      <li class="c8 li-bullet-1"><span class="c5">Who has access to SMS data?</span></li>
    </ol>
    <p class="c3 c25"><span class="c5"></span></p>
    <p class="c2"><span class="c23">The Company may disclose any information (personal/financial, etc.) with the
        following parties, in connection with and as required for the operation of its business/functions:</span>
    </p>
    <ul class="c4 lst-kix_list_3-1 start">
      <li class="c28 c10 c53 li-bullet-1"><span class="c0">Banks and/or authorised external third
          parties/intermediaries or any other service provider involved in transaction processing and services
          with relation to any products, unless a customer expressly requests in writing that such information not
          be shared with such parties.</span></li>
      <li class="c19 c10 c28 li-bullet-2"><span class="c0">Any regulatory/administrative/legislative authority and/or
          with the Company for compliance with any legal, statutory or regulatory requirements and/or to verify
          your identity for complying with anti-money laundering/Know Your Customer requirements and/or under any
          applicable laws in force at the time and/or for the purpose of data storage.</span></li>
      <li class="c19 c28 c10 li-bullet-1"><span class="c0">The Company communicates the aforementioned information
          with the aforementioned service providers under strict confidentiality and solely on a &quot;need to
          know&quot; basis and for the lawful operation of its business/operations.</span></li>
      <li class="c19 c28 c10 li-bullet-1"><span class="c0">The Company will only share such financial information
          relevant to you via a secure Internet connection. In addition, the Company ensures that the parties with
          which this information/data is shared have confidentiality requirements and high-level security
          policies, controls, and procedures in place to ensure its protection.</span></li>
      <li class="c10 c11 li-bullet-1"><span class="c0">The Company shall not be responsible or liable, either directly
          or indirectly, for the authenticity/accuracy of the personal/financial information or any other
          data/information submitted by you and/or for its misuse, which is not attributable to the acts of the
          Company, at any time and in any manner.</span></li>
    </ul>
    <ol class="c4 lst-kix_list_9-1" start="10">
      <li class="c2 c46 li-bullet-2"><span class="c5">How have we protected your Privacy and Security?</span></li>
    </ol>
    <p class="c3 c10"><span class="c5"></span></p>
    <p class="c2"><span class="c0">We treat your personal information and your use of the Service as private and
        confidential, and we do not have any access to any private number or SMS received via a private no. We will
        not send you unsolicited information unless expressly agreed to or required for operational or regulatory
        reasons. However, in order for you to take full advantage of our services, we may send you messages about
        our products/services and/or changes, additions, and improvements to the products/services we offer. Data
        theft is possible as a result of unauthorized hacking, virus attacks, or technical issues which are out of
        the control of the Company, and the Company accepts no liability or responsibility for it. Further, the Data
        will be secured using the best security measures currently available and provided by the
        infrastructure.</span></p>
    <p class="c3 c10"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-0" start="4">
      <li class="c9 c15 li-bullet-0"><span class="c5">WHY DO WE COLLECT THIS INFORMATION?</span></li>
    </ol>
    <p class="c3"><span class="c5"></span></p>
    <p class="c9"><span class="c0">The primary reason we gather information is for customer pre-onboarding diligence and
        customer service post-onboarding. We also use this information to improve our services, website content and
        navigation, monitor usage of our Mobile App and diagnose problems with our server, gather broad demographic
        information and provide you with customized content and advertising, including sending you information about
        new products or promotions using Whatsapp and / or SMS.</span></p>
    <p class="c9"><span class="c0">The collected information may be utilized, stored in servers located only in the
        territory of India, and processed by us to deliver, personalize, measure, and enhance our products and
        services and establish and sustain a secure and trusted environment, including compliance with our legal
        obligations and adherence to our policies.</span></p>
    <p class="c3"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-0" start="5">
      <li class="c9 c15 li-bullet-0"><span class="c5">CONSENT OBLIGATION AND DATA RETENTION UNDER THE DIGITAL PERSONAL
          DATA PROTECTION ACT, 2023</span></li>
    </ol>
    <p class="c3"><span class="c0"></span></p>
    <p class="c9"><span class="c0">For compliance under the Digital Personal Data Protection Act, 2023, you hereby
        voluntarily and without any coercion, give a valid, binding, and explicit authorization and consent for
        procuring, storing, processing and usage of information including but not limited to personal information as
        covered under this Privacy Policy and any other information as may be required to fulfil various obligations
        related to the Services and under applicable laws, rules, regulations, and guidelines and agree to take all
        the necessary actions required for the purpose of usage, authentication, and verification of such
        information. &nbsp;</span></p>
    <p class="c3"><span class="c0 c20"></span></p>
    <p class="c9"><span class="c23">Data Retention: </span><span class="c0">Retention of personal data is only for the
        duration necessary for us to fulfil the purposes mentioned in the privacy policy. Personal Data will be
        retained only for the duration necessary to fulfill the purposes elucidated in this Privacy Policy, unless a
        longer retention period is necessitated by law or for directly related legitimate business purposes. Once
        the Personal Data is no longer required, it will be disposed of securely under due intimation to you. In alignment with industry standards, we will retain the data for six months, after which the credit report will be permanently deleted.</span>
    </p>
    <p class="c3"><span class="c0"></span></p>
    <p class="c3"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-0" start="6">
      <li class="c9 c15 li-bullet-0"><span class="c5">WILL JAI-KISAN SHARE ANY OF THE PERSONAL INFORMATION IT
          RECEIVES?</span></li>
    </ol>
    <p class="c3"><span class="c5"></span></p>
    <p class="c9"><span class="c0">We neither rent nor sell your Personal Information in personally identifiable form to
        anyone. We share your Personal Information in personally identifiable form with third parties only as
        described below:</span></p>
    <ol class="c4 lst-kix_list_9-1" start="11">
      <li class="c28 c25 c31 li-bullet-1"><span class="c5">Affiliated Businesses and Third Party Websites We Do Not
          Control:</span></li>
    </ol>
    <p class="c9 c34"><span class="c0">In certain situations, businesses or third party websites we&rsquo;re affiliated
        in order to provide services to you through the Mobile App (either alone or jointly with us). You can
        recognize when an affiliated business is associated with such a transaction or service, and we will share
        your Personal Information with that affiliated business only to the extent that we deem it related to such
        transaction or service. One such service may include the ability for you to automatically transmit
        information from your Bharat Khata account to an account on a third party website or service, such as
        Facebook. We have no control over the policies and practices of third party websites or businesses as to
        privacy or anything else, so if you choose to take part in any transaction or service relating to an
        affiliated website or business, please review all such business&rsquo;s or websites&rsquo; policies. We use
        the following sub-contractors/technology service providers to help us provide better Service to you. Some of
        your data/data concerning the Services may be shared with the following entities and/or stored in their
        systems:</span></p>
    <p class="c3 c34"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-2 start" start="1">
      <li class="c17 li-bullet-3"><span class="c0">For Identity Verification: Perfios Software Solutions Private
          Limited, Hyperverge Technologies Private Limited, Signzy Technologies&nbsp;Private Limited, AuthBridge
          Research Services Private Limited, Bureauid India Private Limited</span></li>
      <li class="c17 li-bullet-4"><span class="c0">For e-signing: Digiotech Solutions Private Limited</span></li>
      <li class="c17 li-bullet-5"><span class="c0">Bank verification/Nach Setup: Digiotech Solutions Private Limited,
          Desk Nine Private Limited, Cashfree Payments India Private Limited, BrokenTusk Technologies Private
          Limited.</span></li>
      <li class="c17 li-bullet-4"><span class="c0">For analytics and Communications: Mixpanel Inc., Google Inc.,
          MoEngage India Private Limited, Blitzllama Labs Inc.</span></li>
      <li class="c17 li-bullet-6"><span class="c0">Underwriting: CRIF High Mark Credit Information Services Pvt. Ltd.,
          TransUnion CIBIL Limited, Digitap.Ai Enterprise Solutions Private Limited, Wonderlend Hubs Private
          Limited.</span></li>
      <li class="c17 li-bullet-6"><span class="c0">Repayments: Analog Legalhub Technology Solution Private Limited,
          Razorpay Technologies Private Limited, Fino Payments Bank Limited, Yes Bank Limited, Conflux
          Technologies Private Limited (LMS).</span></li>
      <li class="c17 li-bullet-3"><span class="c0">&nbsp;Infrastructure: Amazon Web Services, Inc. and Google
          Inc.</span></li>
    </ol>
    <p class="c42 c33"><span class="c0"></span></p>
    <p class="c33 c42"><span class="c35"></span></p>
    <ol class="c4 lst-kix_list_9-1" start="12">
      <li class="c28 c25 c49 li-bullet-1"><span class="c5">Agents:</span></li>
    </ol>
    <p class="c9 c34"><span class="c0">We employ other companies and people to perform tasks on our behalf and need to
        share your information with them to provide products or services to you. Examples include sending postal
        mail, e-mails, SMSs and Whatsapp messages, removing repetitive information from customer lists, analysing
        data, providing marketing assistance, providing search results and links (including paid listings and
        links), processing credit card payments and providing customer service. Unless we inform you otherwise, our
        agents do not have any right to use the Personal Information we share with them beyond what we deem
        necessary to assist us in performing such tasks.</span></p>
    <ol class="c4 lst-kix_list_9-1" start="13">
      <li class="c31 c28 c25 li-bullet-2"><span class="c5">User Profiles and Content:</span></li>
    </ol>
    <p class="c9 c34"><span class="c0">Certain user profile information, including without limitation a user&rsquo;s
        username and the image content that such user has uploaded to the website may be displayed to other users to
        facilitate user interaction within the Mobile App or address your request for our services. Any content you
        upload to your public user profile, along with any Personal Information or content that you voluntarily
        disclose online in a manner other users can view (on discussion boards, in messages and chat areas, etc.)
        becomes publicly available, and can be collected and used by others. Your username may also be displayed to
        other users if and when you post comments or upload images through the Mobile App and other users can
        contact you through such comments. If you sign into the Services through Facebook Connect, your list of
        &ldquo;friends&rdquo; from Facebook may be automatically imported to the Services, and such
        &ldquo;friends,&rdquo; if they are also registered users of the Services, may be able to access certain
        non-public information you have entered in your Services user profile. Again, we do not control the policies
        and practices of any other third party site or service.</span></p>
    <ol class="c4 lst-kix_list_9-1" start="14">
      <li class="c31 c28 c25 li-bullet-1"><span class="c5">Business Transfers:</span></li>
    </ol>
    <p class="c9 c34"><span class="c0">We may choose to buy or sell assets. In these types of transactions, customer
        information (which may include your Personal Information) is typically one of the business assets that is
        transferred. Also, if we (or substantially all of our assets) are acquired, or if we go out of business or
        enter bankruptcy, Personal Information would be one of the assets transferred to or acquired by a third
        party. </span></p>
    <ol class="c4 lst-kix_list_9-1" start="15">
      <li class="c31 c28 c25 li-bullet-2"><span class="c5">Protection of Jai-Kisan and Others:</span></li>
    </ol>
    <p class="c9 c34"><span class="c0">We may release Personal Information when we believe in good faith that release is
        necessary to comply with laws; enforce or apply our conditions of use and/or other agreements; or protect
        the rights, property, or safety of Jai Kisan, our employees, our users, or others. We may exchange
        information with other companies and organizations (including governmental authorities) for fraud protection
        and credit risk reduction.</span></p>
    <p class="c3 c34"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-0" start="7">
      <li class="c9 c15 li-bullet-0"><span class="c5">IS PERSONAL INFORMATION ABOUT ME SECURE?</span></li>
    </ol>
    <p class="c3"><span class="c5"></span></p>
    <p class="c9"><span class="c0">Your account is protected by a password for your privacy and security. You need to
        prevent unauthorized access to your account and Personal Information by selecting and protecting your
        password (or other sign-on protections) appropriately and limiting access to your computer or device by
        signing off after you have finished accessing your account.</span></p>
    <p class="c9"><span class="c0">We endeavor to protect the privacy of your account and other Personal Information we
        hold in our records, but we cannot guarantee complete security. Unauthorized entry or use, hardware or
        software failure, and other factors may compromise the security of user information at any time.</span></p>
    <p class="c9"><span class="c0">The Mobile App may contain links to other sites. We are not responsible for the
        content or services on such other sites, nor for their privacy policies and/or practices. When following a
        link to another site you should read that site&rsquo;s privacy policy.</span></p>
    <p class="c3"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-0" start="8">
      <li class="c9 c15 li-bullet-0"><span class="c5">WHAT PERSONAL INFORMATION CAN I ACCESS POST ONBOARDING?</span>
      </li>
    </ol>
    <p class="c3"><span class="c5"></span></p>
    <p class="c9"><span class="c0">Through your account settings, you may access, and, in some cases, edit or delete the
        following information you&rsquo;ve provided to us:</span></p>
    <ul class="c4 lst-kix_list_5-0 start">
      <li class="c53 c28 c40 li-bullet-1"><span class="c18 c16">Name and Business Name</span></li>
      <li class="c19 c28 c40 li-bullet-1"><span class="c16 c18">Contact Number</span></li>
      <li class="c19 c28 c40 li-bullet-1"><span class="c18 c16">Location</span></li>
      <li class="c19 c28 c40 li-bullet-1"><span class="c18 c16">Business GST Number</span></li>
      <li class="c19 c28 c40 li-bullet-2"><span class="c18 c16">User PAN Number</span></li>
      <li class="c19 c28 c40 li-bullet-1"><span class="c18 c16">Email Address</span></li>
      <li class="c19 c28 c40 li-bullet-1"><span class="c18 c16">Billing Information</span></li>
      <li class="c11 c40 li-bullet-1"><span class="c18 c16">User profile information and User Content, Including
          images you have uploaded on the app.</span></li>
    </ul>
    <p class="c9"><span class="c16">The information you can view and update may change as the Mobile App changes. If you
        have any questions about viewing or updating information, we have on file about you, please contact us at
      </span><span class="c16 c47"><a class="c21"
          href="mailto:contact@bharatkhata.com">contact@bharatkhata.com</a></span><span class="c0">.</span></p>
    <p class="c3"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-0" start="9">
      <li class="c9 c15 li-bullet-0"><span class="c5">WHAT CHOICES DO I HAVE?</span></li>
    </ol>
    <p class="c3"><span class="c5"></span></p>
    <p class="c9"><span class="c23">You can always elect not to disclose information to us and with respect to the
        consent already provided by you, you shall have the right to withdraw such consent at any time, with the
        ease of doing so by just writing to us at </span><span class="c16 c54"><a class="c21"
          href="mailto:contact@bharatkhata.com">contact@bharatkhata.com</a></span><span class="c0">.</span></p>
    <p class="c3"><span class="c0"></span></p>
    <p class="c9"><span class="c0">However, please note that we may need some information to allow you to onboard and
        register with us or to offer some or all of our features, and if you choose not to provide that information,
        your ability to use our Mobile App and services may be less efficient to the extent of not being able to
        avail the full benefits of the Application. We shall not retain your Information if it is no longer required
        by Us and there is no legal requirement to retain the same under any applicable law. Please note that
        multiple legal bases may exist in parallel, and We may still have to retain certain Information at any
        time.</span></p>
    <p class="c9"><span class="c0">You may be able to add, update, or delete information as explained above. When you
        update information, however, we may maintain a copy of the unrevised information in our records. You may
        request deletion of your account by visiting your account settings. Please note that some data points may
        remain in our private records after your deletion of such information from your account for audit trail
        purpose. Please note, that the retained information will be stored in our Lender Partner&rsquo;s database,
        which can be accessed by us as per the required audit purpose</span></p>
    <p class="c9"><span class="c0">If you do not wish to receive email or other mail from us, please change your account
        settings accordingly. </span></p>
    <p class="c3"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-0" start="10">
      <li class="c9 c15 li-bullet-0"><span class="c5">IN COMPLIANCE WITH RBI&rsquo;S DIGITAL LENDING
          GUIDELINES:</span></li>
    </ol>
    <p class="c3"><span class="c5"></span></p>
    <p class="c9"><span class="c16">The BharatKhata application operates as a Digital Lending Application (DLA) with
        Greenizon Agritech Consultancy Private Limited functioning as a Lending Service Provider (LSP) to diverse
        banks and non-banking financial companies (Lenders). This facilitates users&#39; access to various credit
        facilities or similar products from the Lenders (Credit Products). A comprehensive list of lenders is
        available at </span><a class="c16" href="https://www.jai-kisan.com/lender-partners">https://www.jai-kisan.com/lender-partners</a><span class="c0"> Be
        advised that, in addition to this privacy
        policy, you may be subject to the privacy policies of the Lenders as well as other obligations stipulated in
        the loan documents.</span></p>
    <p class="c3"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-1" start="16">
      <li class="c9 c24 li-bullet-0"><span class="c5">Data Collection and Usage:</span></li>
    </ol>
    <p class="c3 c25"><span class="c5"></span></p>
    <ol class="c4 lst-kix_list_9-2" start="8">
      <li class="c1 li-bullet-3"><span class="c0">During availment of our Services, we may share data you have
          previously provided with the Lender(s) or with us. Additional information may be required during the
          application process. Information specifically provided to access Services or generated upon successful
          receipt of credit from the Lenders will be retained to the extent required by us to fulfill the required
          obligations.</span></li>
      <li class="c1 li-bullet-6"><span class="c0">Pertaining to the information specifically provided during the
          application process, the lender shall decide and adhere to a clear policy guideline regarding the
          storage of customer data, including data type, storage duration, data usage restrictions, data
          destruction protocol, security breach handling standards, which can be accessed at </span><span class="c35"><a
            class="c21"
            href="https://www.google.com/url?q=https://docs.google.com/document/d/1Af0iKIpB2oknROHsfRiayjEsROZPGG8EEwyAIimz428/edit&amp;sa=D&amp;source=editors&amp;ust=1712151742195439&amp;usg=AOvVaw05psKo47CgSRnTu0POitKv">Data
            Policy-BK</a></span><span class="c0">.</span><sup><a href="#cmnt3" id="cmnt_ref3">[c]</a></sup><span
          class="c0">&nbsp; The Lending Service Provider shall be given access to such retained data by the
          Lender, only for the required purpose, and the above-mentioned data shall be retained in the
          Lender&rsquo;s database.</span></li>
      <li class="c1 li-bullet-6"><span class="c0">We will not collect or store biometric data within the
          application.</span></li>
      <li class="c1 li-bullet-3"><span class="c0">We will not access mobile phone resources such as files and media,
          contact lists, call logs, telephony functions, etc., in relation to the Services or as part of its role
          as a Digital Lending Application/Lending Service Provider. However, with your explicit prior consent, we
          may seek one-time access to facilities like the camera, microphone, location, or any other necessity for
          onboarding/KYC requirements in connection with our Services.</span></li>
    </ol>
    <p class="c3"><span class="c5"></span></p>
    <ol class="c4 lst-kix_list_9-1" start="17">
      <li class="c9 c24 li-bullet-0"><span class="c5">Data Storage: </span><span class="c0">All data will be housed in
          servers located within India.</span></li>
    </ol>
    <p class="c3 c10"><span class="c5"></span></p>
    <ol class="c4 lst-kix_list_9-1" start="18">
      <li class="c9 c24 li-bullet-0"><span class="c5">Access Revocation and Data Deletion: </span><span class="c0">You
          may revoke access to various access permissions such as contacts permission and SMS permission via your
          mobile operating system&#39;s app settings or similar functions. However, We as Lending Service Provider
          and the Lenders may still retain data as required by applicable law, to the extent that any amounts are
          outstanding under any Credit Products or till the time approved in-principle credit limit is available
          to You, or to the extent any fraud or fraudulent transactions are suspected in connection with the
          Credit Products. Please note, that such retained information in an aggregated manner will be stored in
          our Lender Partner&rsquo;s database, which can be accessed by us as per the required audit
          purpose.</span></li>
    </ol>
    <p class="c3"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-0" start="11">
      <li class="c9 c15 li-bullet-0"><span class="c5">CHANGES TO THIS PRIVACY POLICY</span></li>
    </ol>
    <p class="c3"><span class="c5"></span></p>
    <p class="c9"><span class="c0">We may amend or modify this Privacy Policy from time to time, so please review it
        frequently. Use of information we collect now is subject to the Privacy Policy in effect at the time such
        information is used. If we make changes in the way we use Personal Information, we will take prior consent
        from you by posting an announcement on our Mobile App or contacting you directly via email or other means.
        You are bound by any changes to the Privacy Policy when you use the Mobile App after such changes have been
        first posted.</span></p>
    <p class="c3"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-0" start="12">
      <li class="c9 c15 li-bullet-0"><span class="c5">QUESTIONS OR CONCERNS</span></li>
    </ol>
    <p class="c3"><span class="c5"></span></p>
    <p class="c9"><span class="c0">If you have any questions or concerns regarding our privacy policies, please send us
        a detailed message to contact@bharatkhata.com. We will make every effort to resolve your concerns.</span>
    </p>
    <p class="c3"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-0" start="13">
      <li class="c9 c15 li-bullet-0"><span class="c5">GRIEVANCE OFFICER CUM DATA PROTECTION OFFICER</span></li>
    </ol>
    <p class="c3"><span class="c5"></span></p>
    <p class="c9"><span class="c0">In accordance with Information Technology Act, 2000 and Rule 3(11) of the Information
        Technology (Intermediaries Guidelines) Rules, 2011 and The Digital Personal Data Protection Act, 2023 made
        there under, the contact details of the Grievance Officer cum Data Protection Officer are provided
        below:</span></p>
    <p class="c9"><span class="c0">Name: Mr. Mrityunjaya Yeli</span></p>
    <p class="c9"><span class="c16">Mobile number: </span><span class="c16 c20">+919972588700</span></p>
    <p class="c9"><span class="c0">Address: 7th Floor, Office No. 711, Trade Centre 309 Kalina, Bandra East, Mumbai,
        Maharashtra India 400051</span></p>
    <p class="c9"><span class="c0">Email: grievanceredressalofficerbnpl@jai-kisan.com</span></p>
    <p class="c9"><span class="c0">Time: Mon - Sat (9:00 - 18:00)</span></p>
    <p class="c9"><span class="c0">Any victims of violations by any person of Rule 3 of the Information Technology
        (Intermediaries Guidelines) Rules, 2011, may complain in writing by email to the Grievance Officer, and each
        complaint shall be resolved. </span></p>
    <p class="c3"><span class="c0"></span></p>
    <ol class="c4 lst-kix_list_9-0" start="14">
      <li class="c9 c15 li-bullet-0"><span class="c5">SECURITY AND COMPLIANCE WITH THE DIGITAL PERSONAL DATA
          PROTECTION ACT, 2023, INFORMATION TECHNOLOGY (REASONABLE SECURITY PRACTICES AND PROCEDURES AND SENSITIVE
          PERSONAL DATA OR INFORMATION) RULES, 2011</span></li>
    </ol>
    <p class="c3"><span class="c5"></span></p>
    <p class="c9"><span class="c0">We hereby state that, to the best of our knowledge, we are, and shall remain, fully
        compliant with all requirements of the Digital Personal Data Protection Act, 2023, the Information
        Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules,
        2011. We further state that, apart from complying with applicable regulations, we also follow industry best
        practices to ensure that your Personal Information is not inappropriately used, disclosed, altered,
        destroyed or misplaced.</span></p>
    <p class="c19 c43 c33"><span class="c0"></span></p>
    <p class="c19 c43 c33"><span class="c0"></span></p>
    <p class="c3"><span class="c0"></span></p>
  </div>
</div>